<template>
  <footer class="w-full bg-white">
    <ul
      class="flex flex-wrap lg:flex-nowrap justify-center items-center gap-2 py-4"
    >
      <li><a href="https://oxoformdocs.fra1.digitaloceanspaces.com/6a324c9066a5a5256eb0de3f/reglement.pdf" target="_blank">Règlement</a></li>
      <li>|</li>
      <li><a href="https://oxoformdocs.fra1.digitaloceanspaces.com/6a324c9066a5a5256eb0de3f/mentions.pdf" target="_blank">Mentions légales</a></li>
      <li>|</li>
      <li><a href="https://oxoformdocs.fra1.digitaloceanspaces.com/6a324c9066a5a5256eb0de3f/politique.pdf" target="_blank">Politique de confidentialité</a></li>
      <li>|</li>
      <li><a href="mailto:Charles%20%26%20Alice%20%3Ccontact@promo.dev%3E">Nous contacter</a></li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: "footer-view",
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
